import UserSelectorEmptyMessageBuilder from './UserSelectorEmptyMessageBuilder'
import messageResource from '../../../messageResource'

export default function OvertimeEmptyMessageBuilder(userSelectorGroupsStrategy)
{
    UserSelectorEmptyMessageBuilder.call(this, userSelectorGroupsStrategy);
}

OvertimeEmptyMessageBuilder.prototype = _.create(UserSelectorEmptyMessageBuilder.prototype, {
    createMessages: function()
    {
        UserSelectorEmptyMessageBuilder.prototype.createMessages.call(this);

        var message = messageResource.getMessage("users_selector.reports.no_overtime_enabled", [window.SystemSettings.overtimeNaming]);
        this.messages["noActiveNodes"] = message;
        this.messages["emptyTree"] = message;
    }
});


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/emptyMessagesBuilders/OvertimeEmptyMessageBuilder.js